import { lazy } from "react";
import { authRoles } from "app/auth/authRoles";

const CadastroCalendario = lazy(() => import("./cadastro"));

const calendarioRoutes = [
  {
    path: "/calendario/cadastro",
    component: CadastroCalendario,
    auth: authRoles.secretaria,
  },
];

export default calendarioRoutes;
